import { render, staticRenderFns } from "./DTLists.vue?vue&type=template&id=07fbeb92&"
import script from "./DTLists.vue?vue&type=script&lang=js&"
export * from "./DTLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports